import clsx from 'clsx'
import React, { FC } from 'react'

import styles from './ShoppingCartIcon.module.scss'

type ShoppingCartIconProps = {
  color?: 'black' | 'white'
  onClick?: () => void
} & React.SVGProps<SVGSVGElement>

const ShoppingCartIcon: FC<ShoppingCartIconProps> = ({
  color,
  onClick,
  ...props
}) => {
  return (
    <svg
      onClick={() => onClick && onClick()}
      className={clsx(styles.svg, props.className)}
      id="Ebene_1"
      data-name="Ebene 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 60 60"
    >
      <rect
        className={`${color == 'black' ? styles.black : styles.white}`}
        x="8.45"
        y="22.54"
        width="42.55"
        height="28.77"
      />
      <path
        className={`${color == 'black' ? styles.black : styles.white}`}
        d="M18.23,22.5a11.5,11.5,0,1,1,23,0"
      />
    </svg>
  )
}

export default ShoppingCartIcon
